/** Post-invest layout with sidebar navigation (spec-18). */

import { ExternalLink, FolderOpen, Handshake, LayoutGrid, ListChecks } from 'lucide-react'
import type { NavSection } from '@/layouts/navTypes'
import { WorkspaceLayout } from '@/layouts/WorkspaceLayout'
import { NAV_LABELS, PORTAL_URL } from '@/lib/labels'

/** Sidebar nav sections for post-invest. */
const NAV_SECTIONS: readonly NavSection[] = [
  {
    title: 'Portfolio',
    items: [
      // spec-64 U-100: an open portfolio dossier lives at /postinvest/startup/<id>.
      {
        to: '/postinvest',
        label: 'Portfolio',
        icon: LayoutGrid,
        end: true,
        match: ['/postinvest/startup'],
      },
      { to: '/postinvest/documenten', label: 'Documenten', icon: FolderOpen },
      { to: '/postinvest/doorverwijzingen', label: 'Doorverwijzingen', icon: Handshake },
      { to: PORTAL_URL, label: NAV_LABELS.founderPortal, icon: ExternalLink, external: true },
    ],
  },
] as const

/** The one "Mijn taken" page, inside this module's shell (spec-64 U-011). */
const TASKS_ITEM = { to: '/postinvest/taken', label: NAV_LABELS.myTasks, icon: ListChecks } as const

/**
 * Post-invest shell. The chrome lives in WorkspaceLayout; this component only
 * supplies the nav and the "Mijn taken" footer item.
 */
export function PostinvestLayout() {
  return <WorkspaceLayout navSections={NAV_SECTIONS} footerItem={TASKS_ITEM} />
}
